import { TreeOptions, TreeAdapter, TreeSource } from "@omegagrid/tree";
import rp, { Service, SqlParameterListAdapter} from "@reporting/rp-app-host";
import { Parameter, Thread } from "@reporting/rp-types/etl";

export class ThreadParameterTreeAdapter extends TreeAdapter {

	private data: TreeSource;

	constructor(
		private etlClient: Service,
		private parameter: Parameter
	) { super() }

	async getTree(): Promise<TreeSource> {
		if (this.data) return this.data;

		try {
			this.data = await this.etlClient.get<TreeSource>(`threads/${this.parameter.id_thread || 0}/parameters/${this.parameter.idz}/content`);
			return this.data;
		} catch (error) {
			return [
				{k: null, v: error, icon: {icon: "hexagon-exclamation", color: 'red'}}
			];
		}
	}

	getOptions(): Partial<TreeOptions> {
		const multiselect = /^table/.test(this.parameter.data_type);
		return {
			selectMode: multiselect ? 'multiple' : 'single',
			autoClose: !multiselect,
			allowEmpty: true
		};
	}

}


export class ThreadSqlParameterListAdapter extends SqlParameterListAdapter {

	private _readonly: boolean;

	constructor(
		private etlClient: Service,
		private thread: Thread
	) {
		super();
		this._readonly = this.thread.accounting !== rp.accountingProvider.a;
	}

	async getParameters(): Promise<Parameter[]> {
		return this.etlClient.get(`threads/${this.getParentId()}/parameters`, { scope: this._readonly ? 1 : 0 });
	}

	async delete(parameter: Parameter) {
		await this.etlClient.delete(`threads/${this.getParentId()}/parameters/${parameter.idz}`);
	}

	getParentId() {
		return this.thread.id_thread;
	}

	isReadonly(): boolean {
		return this._readonly;
	}

	getTreeAdapter(parameter: Parameter) : TreeAdapter {
		return new ThreadParameterTreeAdapter(this.etlClient, parameter);
	}

	createComponentId(type: 'form'|'contentEditor'|'valueEditor', parameter?: Parameter): string {
		switch (type) {
			case 'form': return `etl-parameterForm-${parameter ? `${parameter.id_thread}-${parameter.idz}` : this.thread.id_thread}`;
			case 'contentEditor': return `etl-parameterContent-${parameter.id_thread}-${parameter.name}`;
			case 'valueEditor': return `etl-parameterValue-${parameter.id_thread}-${parameter.name}`;
		}
	}

}
